import { Text } from '../../../../cdl/Text/Text';
import { Characters } from '../../../../common/helpers/unicode.helper';

export const EmptyValue = () => <Text color="foreground.muted">{Characters.EN_DASH}</Text>;
